// extracted by mini-css-extract-plugin
export default {"topBg":"Menu_topBg__2LCw3","menuItem":"Menu_menuItem__b7e-s"};